/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The strategy of choice for device selection in rollout policy.
 */
export enum RolloutStrategy {
  BATCH_SEQUENCE = 'BatchSequence',
}
